import { render, staticRenderFns } from "./TheoryEditCard.vue?vue&type=template&id=5ba5b98c&"
import script from "./TheoryEditCard.vue?vue&type=script&lang=ts&"
export * from "./TheoryEditCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports